<template>
  <a class="message-box" :href="info.link" target="_blank">
    <div class="image" :style="{'background-image': `url(${info.imgSrc})`}"></div>
    <div class="content">
      <h1>{{ info.title }}</h1>
      <p class="text" v-if="info.desc">{{ info.desc }}</p>
      <span class="link">{{info.moreDesc}} ></span>
    </div>
  </a>
</template>

<script>
export default {
  props: ['info']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.message-box {
  display: flex;
  box-sizing: border-box;
  padding: 21px;
  border: 1px solid #DADCE1; border-radius: 3px;
  transition: all .3s ease-in-out;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 2px 4px 0 rgba(60, 64, 67, 0.3),
                0 6px 11px 5px rgba(60, 64, 67, 0.15);
  }
  .image {
    flex: none;
    width: 0; height: 0;
    padding-left: 140px; padding-bottom: 180px;
    background-size: cover;
    background-position: center center;
  }
  .content {
    flex: 1;
    position: relative;
    padding: 5px 0;
    margin-left: 30px;
    @include mobile {
      margin-left: 20px;
    }
    h1 {
      margin-bottom: 8px;
      font-size: 22px; font-weight: 500;
      line-height: 24px;
      color: #202124;
      @include limit-line-numbers(1);
      @include mobile {
        @include limit-line-numbers(2);
      }
    }
    .text {
      font-size: 16px; font-weight: 400;
      line-height: 24px;
      @include limit-line-numbers(3);
      @include mobile {
        @include limit-line-numbers(4);
      }
    }
    .link {
      display: block;
      position: absolute; bottom: 5px; left: 0;
      font-size: 14px; font-weight: 500;
      line-height: 1;
      color: #2B85E8;
    }
  }
}
// @include limit-line-numbers(3);
</style>
